
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_9625_3359)","fill":"#00AEEF"}},[_c('path',{attrs:{"d":"M16.125 2.75h-2.063a.188.188 0 01-.187-.188V1.25a.75.75 0 10-1.5 0v3.563a.563.563 0 01-1.125 0V3.125a.375.375 0 00-.375-.375H6.187A.188.188 0 016 2.563V1.25a.75.75 0 00-1.5 0v3.563a.563.563 0 11-1.125 0V3.125A.375.375 0 003 2.75H1.875a1.5 1.5 0 00-1.5 1.5V17a1.5 1.5 0 001.5 1.5h14.25a1.5 1.5 0 001.5-1.5V4.25a1.5 1.5 0 00-1.5-1.5zm0 13.875a.375.375 0 01-.375.375H2.25a.375.375 0 01-.375-.375v-9a.375.375 0 01.375-.375h13.5a.375.375 0 01.375.375v9z"}}),_c('path',{attrs:{"d":"M12.022 10.684h-1.538l-.808-1.885-.008-.016a.746.746 0 00-1.336.016l-.814 1.885H5.976a.709.709 0 00-.675.439.733.733 0 00.184.805l1.343 1.2-.75 1.72a.724.724 0 00.181.837.743.743 0 00.869.096L9 14.726l1.866 1.05a.736.736 0 00.868-.096.724.724 0 00.182-.837l-.75-1.72 1.359-1.205a.729.729 0 00.173-.795.712.712 0 00-.677-.44z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_9625_3359"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h18v18H0z"}})])])])
          )
        }
      }
    